<template>
  <div class="mt-2" id="faq">
    <div class="py-2">
      <FaqItem v-for="(faqItem, i) in faqList" :key="i" :faqItem="faqItem" />
    </div>
  </div>
</template>

<script>
import FaqItem from "./FaqItem.vue";
export default {
  name: "FaqList",
  components: {
    FaqItem,
  },
  data() {
    return {
      faqList: [
        {
          question: "Comment puis-je créer un compte sur Lgame.gg ?",
          answer: `L’inscription des équipes au tournoi se fait en cinq étapes :<br>
                1 - Chaque membre de l’équipe doit créer un compte sur <a href="https://lgame.gg" target="_blank">Lgame.gg</a>, en suivant les <a href="https://youtu.be/15q-SAFSBVI" target="_blank">instructions suivantes</a> .<br>
                2 - Le capitaine de l’équipe doit ensuite créer l’équipe sur <a href="https://lgame.gg" target="_blank">Lgame.gg</a>, en suivant la <a href="https://youtu.be/O-0hvV8WwUY" target="_blank">procédure décrite</a>.<br>
                3 - Le capitaine de l’équipe procède à l’inscription de l’équipe au tournoi.<br>
                4 - Enfin, il faut rejoindre le serveur <a href="https://discord.gg/y6YRZHqV4H" target="_blank">Discord</a> du tournoi.`,
        },
        {
          question: "Où se déroulera la finale du tournoi ?",
          answer: `Les phases de qualification se tiendront en ligne, tandis que la grande finale se jouera au centre gaming WiGame, situé au <a href="https://maps.app.goo.gl/uNzbRc9KBMZ5a7Qq5" target="_blank">Club Wifaq</a>.`,
        },

        {
          question: "Ou se trouve le centre Gaming Wigame ?",
          answer: `Le centre gaming WiGame vous accueille au <a href="https://maps.app.goo.gl/uNzbRc9KBMZ5a7Qq5" target="_blank">Club Wifaq à Rabat</a>, un lieu moderne et convivial dédié aux passionnés d’e-sport et de gaming.`,
        },
      ],
    };
  },
};
</script>

<style lang="css" scoped>
.faq-title {
  color: white;
  font-family: "urbanist" !important;
  font-weight: 900 !important;
}
@media screen and (max-width: 768px) {
  .faq-title {
    font-size: 18pt;
  }
}
</style>
